import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/wearefrank.webp';
import screenshot_target from '../../../images/letterfunnel/erwinbeets.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Erwin Beets"
      firstname="Erwin"
      companyname="WeAreFrank!"
      competition="Mulesoft en Conduction"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/erwinbeets.js